import { z } from 'zod';

export const ApiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.record(z.string(), z.unknown()).optional(),
  }),
  requestId: z.string().optional(),
});
export type ApiError = z.infer<typeof ApiErrorSchema>;

export const PaginationSchema = z.object({
  nextCursor: z.string().nullable(),
  hasNextPage: z.boolean(),
  total: z.number().int().nonnegative().optional(),
});
export type Pagination = z.infer<typeof PaginationSchema>;

export interface ApiResponse<T> {
  data: T;
}

export interface PaginatedResponse<T> {
  data: T[];
  pagination: Pagination;
}

export const PaginationQuerySchema = z.object({
  cursor: z.string().max(200).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(20),
});
export type PaginationQuery = z.infer<typeof PaginationQuerySchema>;

/** Códigos de erro de domínio conhecidos. */
export const ErrorCodes = {
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  FORBIDDEN: 'FORBIDDEN',
  SCHOOL_ACCESS_DENIED: 'SCHOOL_ACCESS_DENIED',
  SCHOOL_NOT_FOUND: 'SCHOOL_NOT_FOUND',
  SCHOOL_CODE_CONFLICT: 'SCHOOL_CODE_CONFLICT',
  INEP_CODE_CONFLICT: 'INEP_CODE_CONFLICT',
  INEP_NOT_FOUND: 'INEP_NOT_FOUND',
  USER_INACTIVE: 'USER_INACTIVE',
  PASSWORD_CHANGE_REQUIRED: 'PASSWORD_CHANGE_REQUIRED',
  RECENT_LOGIN_REQUIRED: 'RECENT_LOGIN_REQUIRED',
  USER_ALREADY_IN_SCHOOL: 'USER_ALREADY_IN_SCHOOL',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  OUVIDORIA_REQUEST_NOT_FOUND: 'OUVIDORIA_REQUEST_NOT_FOUND',
  KNOWLEDGE_ITEM_NOT_FOUND: 'KNOWLEDGE_ITEM_NOT_FOUND',
  KNOWLEDGE_BASE_FULL: 'KNOWLEDGE_BASE_FULL',
  PLATFORM_EMAIL_NOT_VERIFIED: 'PLATFORM_EMAIL_NOT_VERIFIED',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  NOT_FOUND: 'NOT_FOUND',
  STUDENT_NOT_FOUND: 'STUDENT_NOT_FOUND',
  ENROLLMENT_NUMBER_CONFLICT: 'ENROLLMENT_NUMBER_CONFLICT',
  STUDENT_ALREADY_ENROLLED: 'STUDENT_ALREADY_ENROLLED',
  CLASS_NOT_FOUND: 'CLASS_NOT_FOUND',
  CLASS_CODE_CONFLICT: 'CLASS_CODE_CONFLICT',
  TEACHER_NOT_FOUND: 'TEACHER_NOT_FOUND',
  ACADEMIC_YEAR_NOT_FOUND: 'ACADEMIC_YEAR_NOT_FOUND',
  TERM_NOT_FOUND: 'TERM_NOT_FOUND',
  SUBJECT_NOT_FOUND: 'SUBJECT_NOT_FOUND',
  EVENT_NOT_FOUND: 'EVENT_NOT_FOUND',
  REPORT_NOT_FOUND: 'REPORT_NOT_FOUND',
  REPORT_NOT_READY: 'REPORT_NOT_READY',
  AI_UNAVAILABLE: 'AI_UNAVAILABLE',
  RATE_LIMITED: 'RATE_LIMITED',
  CONFLICT: 'CONFLICT',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
} as const;
export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];
